export default class RuntimeUtils {
    static isBrowser() {
        return typeof window !== 'undefined';
    }
    static isNode() {
        return typeof window === 'undefined';
    }
}
//# sourceMappingURL=RuntimeUtils.js.map